import { render, staticRenderFns } from "./multiple-test.vue?vue&type=template&id=9c69e2a0&scoped=true"
import script from "./multiple-test.vue?vue&type=script&lang=js"
export * from "./multiple-test.vue?vue&type=script&lang=js"
import style0 from "./multiple-test.vue?vue&type=style&index=0&id=9c69e2a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c69e2a0",
  null
  
)

export default component.exports